export default __webpack_public_path__ + "static/media/landing-image-glasshouse.29bbc8d5.jpg";